export const API_HOST = "https://cmsapi.fantuan.ca"
// export const API_HOST = "http://54.215.254.190:8088/api"
export const API_HOST_SPRING = "https://cmsapi.fantuan.ca/v2"
export const API_UPLOAD = "https://fantuan.ca"
export const API_SEND_EMAIL = "https://cmsapi.fantuan.ca/v2/submit-applies/email"
